import { render, staticRenderFns } from "./EditorRichText.vue?vue&type=template&id=af648ac2&scoped=true&"
import script from "./EditorRichText.vue?vue&type=script&lang=js&"
export * from "./EditorRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af648ac2",
  null
  
)

export default component.exports